import React, { useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

import CheckoutForm from './CheckoutForm';

import { saveStripeData } from '../../api/payments/saveStripeData';
import { auth } from '../../config/firebase';

import '../../styles/App.css';
import Cookies from 'js-cookie';

// Make sure to call loadStripe outside of a component’s render to avoid
// recreating the Stripe object on every render.

// Stripe publishable key comes from env so test/live flips per environment:
//   • .env             → pk_test_…  (local dev)
//   • .env.production   → pk_live_…  (yarn build / Firebase deploy)
// Publishable keys are safe to ship in client code. The SECRET key
// (sk_live_…) lives ONLY in the backend — never here.
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export default function PaymentCheckout() {
  const [clientSecret, setClientSecret] = useState('');
  const [paymentIntent, setPaymentIntent] = useState('');

  // KBT-195: the `email` cookie is not always set (e.g. the users doc has no
  // email), which left donation PaymentIntents with an empty metadata.email
  // and no receipt. Fall back to the signed-in Firebase user's email.
  const email = Cookies.get('email') || auth?.currentUser?.email || '';
  const customerID = Cookies.get('customerStripeID');

  const storedAmount = localStorage.getItem('amount');
  const paymentType = localStorage.getItem('paymentType');
  const paymentTypeName = localStorage.getItem('paymentTypeName');
  const tickets = localStorage.getItem('tickets');

  // const paymentPlan = 'daily';
  // const paymentType = 'membership';

  useEffect(() => {
    // Create PaymentIntent as soon as the page loads
    const createPaymentIntent = async () => {
      await fetch(`${process.env.REACT_APP_BASE_URL}/create-payment-intent`, {
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${process.env.STRIPE_SECRET_KEY}`,
        },
        body: JSON.stringify({
          items: [{ id: 'kbt-payment' }],
          amount: storedAmount,
          customerID,
          paymentType: paymentType,
          paymentTypeName: paymentTypeName ? paymentTypeName : '',
          email: email ? email : '',
          tickets: tickets ? tickets : [],
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          setClientSecret(data.clientSecret);
          setPaymentIntent(data?.id);
          // The backend may return a fresh customer id (e.g. after the
          // test→live switch, when the stored test customer is invalid).
          // Persist it so future requests reuse the correct live customer.
          if (data?.customerID && data.customerID !== customerID) {
            Cookies.set('customerStripeID', data.customerID);
          }
        });
    };

    createPaymentIntent();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // console.log('tickets in checkout...', tickets);

  useEffect(() => {
    const saveData = async () => {
      if (paymentIntent) {
        try {
          // The live auth uid, with no cookie fallback. Payment.js is this
          // component's only mount point and now refuses to render without a
          // Firebase session, so currentUser is present here — and falling
          // back to the cookie was the last way a payment could be recorded
          // against a uid with no account behind it.
          const uid = auth.currentUser?.uid;
          await saveStripeData(paymentIntent, uid, '', customerID);
        } catch (error) {
          console.error('Error saving paymentIntent:', error);
        }
      }
    };

    saveData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentIntent]);

  const appearance = {
    theme: 'stripe',
  };
  const options = {
    clientSecret,
    appearance,
  };

  return (
    <div className="App">
      {clientSecret && (
        <Elements options={options} stripe={stripePromise}>
          <CheckoutForm paymentType={paymentType} />
        </Elements>
      )}
    </div>
  );
}
